import { useQuery } from '@tanstack/react-query';

import {
  // type components,
  getOnesuranceRecommendationsByEmailId,
  type GetOnesuranceRecommendationsByEmailIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useOnesuranceRecommendations(
  emailId: string,
  options?: QueryOptions<{
    recommendations: GetOnesuranceRecommendationsByEmailIdResponse['items'];
    advice: GetOnesuranceRecommendationsByEmailIdResponse['advice'];
  }>,
) {
  return useQuery({
    queryKey: queryKeys.recommendation(emailId),
    queryFn: async () => {
      const result = await getOnesuranceRecommendationsByEmailId(
        { path: { email_id: emailId } },
        wgApi,
      );

      return {
        recommendations: result.items,
        advice: result.advice,
      };
    },
    ...options,
  });
}
